export default "__VITE_ASSET__BMVXsWXK__"